package org.chiangmeng.qfast.database.shared

import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass
import org.chiangmeng.qfast.database.QFastDatabase
import org.chiangmeng.qfast.database.QueueHistoryQueries

internal val KClass<QFastDatabase>.schema: SqlSchema<QueryResult.Value<Unit>>
  get() = QFastDatabaseImpl.Schema

internal fun KClass<QFastDatabase>.newInstance(driver: SqlDriver): QFastDatabase =
    QFastDatabaseImpl(driver)

private class QFastDatabaseImpl(
  driver: SqlDriver,
) : TransacterImpl(driver), QFastDatabase {
  override val queueHistoryQueries: QueueHistoryQueries = QueueHistoryQueries(driver)

  public object Schema : SqlSchema<QueryResult.Value<Unit>> {
    override val version: Long
      get() = 1

    override fun create(driver: SqlDriver): QueryResult.Value<Unit> {
      driver.execute(null, """
          |CREATE TABLE QueueHistoryEntity (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    shop_id TEXT NOT NULL,
          |    ticket_number INTEGER NOT NULL,
          |    served_at INTEGER NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE LocalActiveQueueEntity (
          |    shop_id TEXT NOT NULL,
          |    ticket_number INTEGER NOT NULL,
          |    category TEXT NOT NULL,
          |    status TEXT NOT NULL,
          |    time TEXT NOT NULL,
          |    call_time TEXT,
          |    pre_order TEXT,
          |    PRIMARY KEY (shop_id, ticket_number)
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE LocalShopStateEntity (
          |    shop_id TEXT PRIMARY KEY NOT NULL,
          |    last_ticket INTEGER NOT NULL DEFAULT 0,
          |    current_servings_json TEXT NOT NULL DEFAULT '{}'
          |)
          """.trimMargin(), 0)
      return QueryResult.Unit
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.Value<Unit> = QueryResult.Unit
  }
}
